import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_Inicio from './Content_Inicio';
import Footer from '../../components/Footer/Footer';

class Home extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_Inicio />
                <Footer />
            </div>

        )
    }
}

export default Home;